import { useChatWindowViewModel } from "./ChatWindowViewModel";
import ConversationSidebar from "./components/ConversationSidebar";
import MessagePanel from "./components/MessagePanel";

const ChatWindow = () => {
  const vm = useChatWindowViewModel();

  return (
    <div className="lds-relative lds-flex lds-h-full lds-min-h-0 lds-overflow-visible before:lds-pointer-events-none before:lds-absolute before:lds-inset-y-0 before:lds-top-[-1rem] before:lds-left-[40%] before:lds-border-l before:lds-border-bordercolor-default before:lds-content-['']">
      <ConversationSidebar vm={vm} />
      <MessagePanel vm={vm} />
    </div>
  );
};

export default ChatWindow;
